const steps = [
  {
    day: "Day 1",
    title: "Free consultation & quote",
    desc: "Tell us about your property and goals. We send a tailored quote with package options within 24 hours - no obligation. Choose a pre-curated collection or go fully bespoke.",
    img: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/dd9c94e1d_generated_image.png",
  },
  {
    day: "Days 2–7",
    title: "Design, sourcing & delivery",
    desc: "Our design team creates your scheme. All furniture, accessories and linen are sourced and delivered. We handle all logistics - you don't need to lift a finger or coordinate a single supplier.",
    img: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/3ae02273b_generated_image.png",
  },
  {
    day: "Days 8–10",
    title: "Installation & styling",
    desc: "Everything is assembled, placed and styled by our team. Final touches applied, property photographed - professionally styled and guest-ready.",
    img: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/d6244f213_generated_image.png",
  },
  {
    day: "Day 14",
    title: "Live on Airbnb",
    desc: "Truestays onboards your property, creates your listings across 16+ platforms, sets dynamic pricing, and goes live. From empty shell to earning income - in just 2 weeks.",
    img: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/6526f66df_generated_image.png",
  },
];

const stepImg = { width: "100%", aspectRatio: "4 / 3", borderRadius: 12, overflow: "hidden", marginBottom: 16 };
const stepImgEl = { width: "100%", height: "100%", objectFit: "cover", display: "block" };

export default function InteriorsProcess() {
  return (
    <section style={{ backgroundColor: "#fff", padding: "clamp(60px, 7vw, 96px) clamp(20px, 5vw, 80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 64 }}>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#888", marginBottom: 12, marginTop: 0 }}>How it works</p>
          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px, 4vw, 46px)", letterSpacing: "-0.02em", color: "#1A1A1A", lineHeight: 1.15, marginBottom: 14, marginTop: 0 }}>
            Empty shell to live listing<br />in 2 weeks.
          </h2>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 16, color: "#666", lineHeight: 1.65, maxWidth: 560, margin: "0 auto" }}>
            The fastest route from an unfurnished property to a fully managed, income-generating Airbnb. Interiors handled in 7 days, live on the platforms within 2 weeks.
          </p>
        </div>

        <div className="process-desktop" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 32 }}>
          {steps.map((step) => (
            <div key={step.day}>
              <div style={stepImg}><img src={step.img} alt={step.title} style={stepImgEl} /></div>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em", color: "#4A6DC7", marginBottom: 10, marginTop: 0 }}>{step.day}</p>
              <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 15, color: "#1A1A1A", marginBottom: 8, marginTop: 0, letterSpacing: "-0.01em", lineHeight: 1.35 }}>{step.title}</p>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, lineHeight: 1.65, color: "#666", margin: 0 }}>{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="process-mobile" style={{ display: "none", flexDirection: "column", gap: 0 }}>
          {steps.map((step, i) => (
            <div key={step.day} style={{ display: "flex", gap: 20 }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#112215", flexShrink: 0, marginTop: 4 }} />
                {i < steps.length - 1 && <div style={{ width: 2, flex: 1, minHeight: 40, background: "#E5E5E5", margin: "4px 0" }} />}
              </div>
              <div style={{ flex: 1, paddingBottom: i < steps.length - 1 ? 32 : 0 }}>
                <div style={{ ...stepImg, maxWidth: 260, marginBottom: 12 }}><img src={step.img} alt={step.title} style={stepImgEl} /></div>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: 10, textTransform: "uppercase", letterSpacing: "0.08em", color: "#4A6DC7", marginBottom: 6, marginTop: 0 }}>{step.day}</p>
                <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 15, color: "#1A1A1A", marginBottom: 6, marginTop: 0 }}>{step.title}</p>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#666", lineHeight: 1.65, margin: 0 }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .process-desktop { display: none !important; }
          .process-mobile { display: flex !important; }
        }
      `}</style>
    </section>
  );
}